import {useEffect, useRef, useState,} from 'react';

const popupTrigger = (
    polygonRef,
    popupRef,
    isScroll
) => {
    const polygonRect = polygonRef?.current?.getBoundingClientRect()
    const popup = popupRef?.current?.getBoundingClientRect()
    const top = polygonRect?.height / 2 + polygonRect?.y - popup?.height
    const left = polygonRect?.width / 2 + polygonRect?.x - popup?.width / 2

    if (popupRef.current) {
        popupRef.current.style.cssText = `
			${popup.x !== 0 && !isScroll ? 'transition: transform .3s;' : ''}
			transform: translate(${left}px,${top}px);
			opacity: 1;
		`
    }
};

export const useMapHandler = (regions) => {
    const popupRef = useRef(null);
    const polygonRef = useRef(null);
    const [regionName, setRegionName] = useState(null);
    const [select, setSelect] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            if ((polygonRef?.current?.contains(e.target) || e.target.parentElement)
                && e.target.parentElement.closest('[data-type="path-group"]')
            ) {
                return popupTrigger(polygonRef, popupRef)
            }
            if (popupRef?.current?.contains(e.target)) return
        }

        const scrollHandler = () => popupTrigger(polygonRef, popupRef, true)
        document.addEventListener('click', handler, false);
        window.addEventListener('scroll', scrollHandler, false);
        return () => {
            document.removeEventListener('click', handler, false);
            window.removeEventListener('scroll', scrollHandler, false);
        };
    });

    useEffect(() => {
        if (!!select) {
            popupTrigger(polygonRef, popupRef)
            setRegionName(regions?.find(item => item.code === select?.code) || null)
        }
    }, [select, setRegionName, regions])

    return {
        polygonRef,
        popupRef,
        regionName,
        select,
        setSelect,
    };
};
